// extracted by mini-css-extract-plugin
export default {"hero":"PageHero_hero__AHE72","inner":"PageHero_inner__h6IWG","eyebrow":"PageHero_eyebrow__436PL","title":"PageHero_title__Xq4wc","description":"PageHero_description__hO993"};